import * as React from 'react';
import { SVGProps } from 'react';
export const ProfileWhiteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M14.645 13.126a7.71 7.71 0 0 0-3.799-3.327 4.75 4.75 0 1 0-5.7 0 7.71 7.71 0 0 0-3.799 3.327.75.75 0 1 0 1.299.75c1.132-1.958 3.132-3.125 5.35-3.125 2.218 0 4.218 1.168 5.35 3.125a.75.75 0 0 0 1.299-.75ZM4.746 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Z"
    />
  </svg>
);
